function Logo() {
	return <img alt="logo supembout" src="/logo.png" />;
}

export default Logo;
